import { css } from 'styled-components';
import token from 'styled-token';
import { dialogCloseMixin } from '../dialogCloseMixin';

/** @class DialogMixin */
/**
 * Adds core styling to `Dialog` based components.
 *
 * @example
 * import { DialogMixin } from "@zillow/constellation";
 *
 * const Component = styled.div`
 *     ${DialogMixin}
 * `;
 *
 * <Component>My dialog component</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
export var DialogMixin = function DialogMixin(props) {
  return token({
    backgroundColor: 'Dialog.backgroundColor',
    boxShadow: 'Dialog.boxShadow',
    borderRadius: 'Dialog.borderRadius'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      boxShadow = _ref.boxShadow,
      borderRadius = _ref.borderRadius;
    return css(["box-sizing:border-box;background-color:", ";box-shadow:", ";outline:none;border-radius:", "px;", ""], backgroundColor, boxShadow, borderRadius, dialogCloseMixin(props));
  })(props);
};